import React from "react";

/**
 * Bannière d'en-tête de page admin (façon hero Skills Academy) : titre + sous-titre
 * sur fond dégradé/halo ambre, avec une zone d'actions optionnelle à droite et un
 * bouton "retour" optionnel à gauche. Réutilisable sur toutes les pages admin.
 *
 * Props :
 *  - title    : titre principal (string ou node)
 *  - subtitle : texte secondaire optionnel (string ou node)
 *  - actions  : contenu optionnel aligné à droite (boutons, liens…)
 *  - back     : contenu optionnel aligné à gauche du titre (ex. bouton "Retour")
 */
const AdminFormHeader = ({ title, subtitle, actions, back }) => (
  <div className="admin-form-header">
    {back && <div className="admin-form-header-back">{back}</div>}
    <div className="admin-form-header-main">
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </div>
    {actions && <div className="admin-form-header-actions">{actions}</div>}
  </div>
);

export default AdminFormHeader;
